/**
 * @author lwo
 */
import { send } from "./Metric";
import { getExperiments, getExperimentVersion } from "../experiments/info";

const EXPERIMENTS_CLICKOUT_COMPLETE = "experiments_clickout";
const EXPERIMENTS_UNIQUE_VISIT = "experiments_unique_visit";

function addVersion(prefix, experiment) {
	return prefix + `_${experiment}_${getExperimentVersion(experiment)}`;
}

export const trackConversion = () => {
	getExperiments().forEach(experiment => {
		// Tracks every clickout.
		send(addVersion("experiments_conversions", experiment), 1);
		// Tracks the first clickout.
		if (
			!localStorage.getItem(
				addVersion(EXPERIMENTS_CLICKOUT_COMPLETE, experiment),
			)
		) {
			localStorage.setItem(
				addVersion(EXPERIMENTS_CLICKOUT_COMPLETE, experiment),
				true,
			);
			send(addVersion("experiments_first-conversions", experiment), 1);
		}
	});
};

getExperiments().forEach(experiment => {
	// Tracks site traffic.
	if (!localStorage.getItem(addVersion(EXPERIMENTS_UNIQUE_VISIT, experiment))) {
		localStorage.setItem(
			addVersion(EXPERIMENTS_UNIQUE_VISIT, experiment),
			true,
		);
		send(addVersion("experiments_visits", experiment), 1);
	}
});
